// CHANGED: First spin discount bundles removed per product request
// CHANGED: 1 token option restored; 16 token option temporarily removed
const TOKEN_BUNDLES = [
  { id: 'token-1', tokens: 1, price: 3, label: 'Single token' },
  { id: 'token-4', tokens: 4, price: 12, label: 'Warm-up bundle' },
  { id: 'token-9', tokens: 9, price: 27, label: 'Collector pack' },
  // { id: 'token-16', tokens: 16, price: 48, label: 'Locker hoard' }, // Temporarily removed
  { id: 'token-25', tokens: 25, price: 75, label: 'Vault cache' },
];

export const findBundleById = (bundleId) => {
  if (typeof bundleId !== 'string' || bundleId.trim().length === 0) {
    return null;
  }
  return TOKEN_BUNDLES.find((bundle) => bundle.id === bundleId.trim()) || null;
};

export const findBundleByTokens = (tokens) => {
  const parsed = Number(tokens);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }
  return TOKEN_BUNDLES.find((bundle) => bundle.tokens === parsed) || null;
};

export default TOKEN_BUNDLES;
